<template>
	<div v-bind:class="['patient', {
		corrected: providedValidEvent,
		error: invalidEvent && !skipPatient
	}]">
		<!-- <div class="action">
			<el-button v-if="invalidPatient"
				v-bind:type="skipPatient ? 'primary' : 'danger'" size="small"
				@click="toggleSkipPatient">
				<b>{{ skipPatient ? 'Select Patient Event' : 'Skip Patient' }}</b>
			</el-button>
		</div> -->

		<div class="account">
			<span class="name">
				<strong>{{ index }}. {{ patient.data.name }}</strong>
				<div v-if="patient.data.email" class="extra-info">
					{{ patientProviderNames }}
				</div>
				<template v-if="patient.data.phone || patient.data.email">
					<br>
					<small> 
						<template v-if="patient.data.email"> {{ patient.data.email }}</template>
						{{ patient.data.phone && patient.data.email ?  ',' : ''}}
						<template v-if="patient.data.phone">{{ patient.data.phone }}</template>
					</small>
				</template>
			</span>

			<ol class="events" :class="patientEvents.length > 1 ? 'multiple' : 'single'">
				<li v-for="(event, index) in patientEvents"
					:key="index + event.row"
					v-bind:class="['event', { confirmed: !confirm || event.id != null }]">
					<EventEdit :event="event" 
						@edit="editEvent($event, event)"
						@select="selectedEvent"
						:confirm="confirm"></EventEdit>
				</li>
			</ol>

			<!-- <template>
				<div class="confirmed event" v-for="(event, index) in patient.data.event">
					<i class="el-icon-date"></i>
					<strong>{{ getContentKey('event', event.id, 'name') }}</strong> on <strong>{{ formatDate(event.time, true, true) }}</strong>
				</div>
			</template> -->
		</div>
		<ImportData
			:patient="patient"
			:column="column"
			:highlight="['date', 'time', 'event', 'code', 'doctor']"
			:show-patient="patientEvents">
		</ImportData>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

import sameDay from '@/module/util/same-day'

import EventEdit from './EventEdit'
import ImportPatientRow from '.'

export default {
	name: 'import-patient-event-row',
	extends: ImportPatientRow,
	props: {
		sameSchedule: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			providedValidEvent: !this.confirm,
			eventId: null
		}
	},

	watch: {
		eventId(id) {

		}
	},

	methods: {
		selectedEvent() {
			this.providedValidEvent = true			
			Vue.set(this.patient, 'selectedEvent',
				this.patient.data.event.every((event) => event.id != null))
		},
		editEvent(edit, event) {
			event.id = null
			Vue.set(this.patient, 'selectedEvent',
				this.patient.data.event.every((event) => event.id != null))
		}
 	},

	computed: {
		...mapGetters('provider', [ 'getProvider' ]),
		...mapGetters('content', [ 'getContent', 'getContentKey' ]),
		invalidEvent() {
			return this.patient.data.event.some((event) => event.id == null)
		},
		provider() {
			return this.getProvider
		},
		events() {
			return [].concat.apply([], this.provider.profile.map((p) => p.event))
					 .map((id) => this.getContent('event', id))
					 .filter((e) => e != null)
		},
		patientEvents() {
			if(this.sameSchedule) {
				return this.patient.scheduleData
			}
			return this.patient.data.event
		}
	},
	components: {
		EventEdit
	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";

.patient {
	min-height: 70px;

	.account {
		min-height: 70px;
	}
}
</style>
